
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * EventType enum
 */
class EventType {
  /**
   * Initialize enum with a given value
   * @param {EventType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof EventType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!EventType}
   * @param {!EventType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof EventType)) {
      throw new TypeError('Instance of EventType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!EventType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!EventType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === EventType.NONE.value) {
      return 'NONE'
    }
    if (this.value === EventType.RESET_MANAGER_PASSWORD.value) {
      return 'RESET_MANAGER_PASSWORD'
    }
    if (this.value === EventType.DEPRECATED_SEND_CLIENT_REPORT.value) {
      return 'DEPRECATED_SEND_CLIENT_REPORT'
    }
    if (this.value === EventType.LEVERAGE_CHANGE.value) {
      return 'LEVERAGE_CHANGE'
    }
    if (this.value === EventType.DAILY_CLIENT_REPORT.value) {
      return 'DAILY_CLIENT_REPORT'
    }
    if (this.value === EventType.MONTHLY_CLIENT_REPORT.value) {
      return 'MONTHLY_CLIENT_REPORT'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!EventType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!EventType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!EventType} Created enum
   */
  static fromObject (other) {
    return new EventType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
EventType.NONE = new EventType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
EventType.RESET_MANAGER_PASSWORD = new EventType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
EventType.DEPRECATED_SEND_CLIENT_REPORT = new EventType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
EventType.LEVERAGE_CHANGE = new EventType(0 + 3)
// noinspection PointlessArithmeticExpressionJS
EventType.DAILY_CLIENT_REPORT = new EventType(0 + 4)
// noinspection PointlessArithmeticExpressionJS
EventType.MONTHLY_CLIENT_REPORT = new EventType(0 + 5)

export { EventType };

/**
 * Fast Binary Encoding EventType field model
 */
class FieldModelEventType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelEventType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelEventType}
   * @param {EventType=} defaults Default value, defaults is new EventType()
   * @returns {!EventType} Result value
   */
  get (defaults = new EventType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new EventType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelEventType}
   * @param {!EventType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelEventType };
